import axios from './axios';

export default class MessagesService {
  static sendMessage(payload) {
    const config = {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    };

    return axios.post(window.entityCabinetSettings.openApi.url + '/api/chat/message/send', payload, config);
  }
}